import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {
    IFirstPaymentDays
} from "../../../../../../../utils/interfaces/my_documents/fiscal_registry/payment/IFirstPaymentDays";


const useApiGetFirstPaymentDays = (pk: number | undefined): UseQueryResult<IFirstPaymentDays, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined, pk: number | undefined): Promise<IFirstPaymentDays> {
        try {
            const response = await get(`/api/company/${company_token}/my_documents/payment/first_payment_days/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetFirstPaymentDays", pk],
        queryFn: () => doGet(selectedCompany?.company_token, pk),
        enabled: !!pk
    })
};

export default useApiGetFirstPaymentDays